import $ from 'jquery';

export default {

	init() {

		function HomepageCalcTopPosition( url , variable ) {

			var query = url.split('?')[1];

			if( query ) {

				var parameters = query.split('&');
				var sectionName;

				parameters.forEach( function(cell, index) {

					parameters[index] = cell.split('=');

				});

				parameters.forEach( function(cell, index) {

					if( cell[0] == variable ) {

						sectionName = cell[1];

					}

				});

				var section = document.querySelector('.'+sectionName );

				if( section ) {

					return section.offsetTop - document.querySelector('header').offsetHeight;

				}

			}

		}

		function HomepageScroll( topPosition ) {

			$('html ,body').animate({'scrollTop': topPosition }, 'smooth');

		}

		function HomepageScrollToNewsLetter( container ) {

			HomepageScroll( HomepageCalcTopPosition( window.location.href, variable ) );

			var bottomMenu = document.querySelectorAll('footer a.footer__bottomMenuItem');

			if( bottomMenu ) {

				bottomMenu.forEach( function( item,index ) {

					item.addEventListener('click', function(e){

						e.preventDefault();

						if( item.getAttribute('href').split('?')[1] ) {

							HomepageScroll( HomepageCalcTopPosition( item.getAttribute('href'), variable ) );

						} else {

							window.location.href = item.getAttribute('href');

						}

					});

				});

			}

		}

		var container = document.querySelector('main.homepage');

		if( container ) {

			var variable = container.getAttribute('data-variable');

			if( variable ) {

				HomepageScrollToNewsLetter( container );

			}

		}

	},
	finalize() {

	}

}